/**
 * 阶段 1 UI / 每日意图状态（用 localStorage 持久化，便于刷新后继续演示）。
 *
 * 真实实现（阶段 2）：
 *   - onboardingDone / dailyIntent 主要由 IndexedDB 保存，localStorage 仅作非关键 UI 设置；
 *   - DailyIntent 以 (userId, localDate) 唯一，服务端去重（ADR-008 / 决策 14.10）。
 */
import { create } from "zustand";
import { persist } from "zustand/middleware";
import type { DailyIntentType } from "@jilian/shared";
import type { ReadinessResult } from "@jilian/core";

interface AppState {
  onboardingDone: boolean;
  setOnboardingDone: (v: boolean) => void;

  /** 今日意图（train / rest / nutrition_only），null = 今天还没确认。 */
  todayIntent: DailyIntentType | null;
  setTodayIntent: (v: DailyIntentType) => void;

  /** 最近一次恢复问询结果（用于「今日」展示调整原因）。 */
  lastReadiness: ReadinessResult | null;
  setLastReadiness: (r: ReadinessResult | null) => void;
}

export const useAppStore = create<AppState>()(
  persist(
    (set) => ({
      onboardingDone: false,
      setOnboardingDone: (v) => set({ onboardingDone: v }),
      todayIntent: null,
      setTodayIntent: (v) => set({ todayIntent: v }),
      lastReadiness: null,
      setLastReadiness: (r) => set({ lastReadiness: r }),
    }),
    { name: "jilian-app" },
  ),
);
